<template>
    <treeselect :value="value || null"
                :options="options"
                @input="onInput"
                :disableBranchNodes="disableBranchNodes"
                :multiple="multiple"
                :placeholder="placeholder"
                :max-height="maxHeight"
                :normalizer="normalizer"
                class="field-treeselect">
        <template v-slot:value-label="{ node }">
            {{ convertFieldPathToLabel(node.id) }}
            <slot name="after-value-label"></slot>
        </template>
    </treeselect>
</template>

<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Treeselect from '@riophae/vue-treeselect'
import {startCase} from 'lodash'

export default {
    name: 'ESFieldTreeselect',
    components: {
        Treeselect
    },
    props: {
        value: {
            type: [Array, String]
        },
        mappingPropsTree: {
            type: Object,
            required: true
        },
        placeholder: {
            type: String,
            default: 'Select field'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disableBranchNodes: {
            type: Boolean,
            default: true
        },
        maxHeight: {
            type: Number,
            default: 180
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    computed: {
        options() {
            return _.get(this.mappingPropsTree, 'children', [])
        }
    },
    methods: {
        onInput(fieldPath) {
            if (fieldPath === undefined) {
                fieldPath = ''
            }
            this.$emit('input', fieldPath)
        },

        normalizer(node) {
            return {
                id: node.id,
                label: this.convertFieldPathToLabel(node.label),
                children: node.children
            }
        },

        convertFieldPathToLabel(path) {
            return startCase(path)
        }
    }
}
</script>

<style lang="scss">
.field-treeselect {
    width: 100%;

    .vue-treeselect {
        &__icon {
            color: $color-black-soft;
        }

        &__multi-value-label {
            line-height: 8px;
            height: 24px;
            font-size: 14px;
            display: inline-block;
            vertical-align: middle;
        }

        &__placeholder,
        &__single-value {
            height: 38px;
            line-height: 38px;
            box-sizing: border-box;
        }

        &__input {
            vertical-align: middle;
            font-size: 14px !important;
        }

        &__input-container {
            height: 36px;
            line-height: 36px;
        }

        &__multi-value {
            margin: 0;
            line-height: 20px;
            height: 100%;
        }

        &__multi-value-item-container {
            padding-top: 0;
            margin-top: 0;
            padding-bottom: 2px;
            margin-bottom: 2px;
            height: 34px;
            line-height: 34px;
            vertical-align: middle;
        }

        &__multi-value-item {
            color: $color-black-soft;
            background-color: $color-purple-soft;
            height: 24px;
            line-height: 24px;
            vertical-align: middle;
            padding: 0;
        }

        &__label-container:hover &__checkbox--unchecked {
            border-color: $color-purple-light;
            background: #fff;
        }

        &__checkbox--indeterminate {
            border-color: $color-purple-light;
            background: $color-purple-light;
        }

        &__label-container:hover .vue-treeselect__checkbox--indeterminate {
            border-color: $color-purple-light;
            background: $color-purple-light;
        }

        &__checkbox--checked {
            border-color: $color-purple-light;
            background: $color-purple-light;
        }

        &__label-container:hover .vue-treeselect__checkbox--checked {
            border-color: $color-purple-light;
            background: $color-purple-light;
        }

        &__checkbox--disabled {
            border-color: #e0e0e0;
            background-color: #f7f7f7;
        }
    }
}
</style>
